!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.TextTransition = t(require("react")) : e.TextTransition = t(e.React);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 29);
  }([function (e, t, n) {
    e.exports = n(25)();
  }, function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = "number" == typeof e[n] ? e[n] : e[n].val);
      }

      return t;
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e, t, n) {
      for (var r in t) {
        if (Object.prototype.hasOwnProperty.call(t, r)) {
          if (0 !== n[r]) return !1;
          var o = "number" == typeof t[r] ? t[r] : t[r].val;
          if (e[r] !== o) return !1;
        }
      }

      return !0;
    }, e.exports = t.default;
  }, function (e, t, n) {
    (function (t) {
      for (var r = n(26), o = "undefined" == typeof window ? t : window, i = ["moz", "webkit"], a = "AnimationFrame", l = o["request" + a], u = o["cancel" + a] || o["cancelRequest" + a], s = 0; !l && s < i.length; s++) {
        l = o[i[s] + "Request" + a], u = o[i[s] + "Cancel" + a] || o[i[s] + "CancelRequest" + a];
      }

      if (!l || !u) {
        var c = 0,
            f = 0,
            p = [];
        l = function l(e) {
          if (0 === p.length) {
            var t = r(),
                n = Math.max(0, 1e3 / 60 - (t - c));
            c = n + t, setTimeout(function () {
              var e = p.slice(0);
              p.length = 0;

              for (var t = 0; t < e.length; t++) {
                if (!e[t].cancelled) try {
                  e[t].callback(c);
                } catch (e) {
                  setTimeout(function () {
                    throw e;
                  }, 0);
                }
              }
            }, Math.round(n));
          }

          return p.push({
            handle: ++f,
            callback: e,
            cancelled: !1
          }), f;
        }, u = function u(e) {
          for (var t = 0; t < p.length; t++) {
            p[t].handle === e && (p[t].cancelled = !0);
          }
        };
      }

      e.exports = function (e) {
        return l.call(o, e);
      }, e.exports.cancel = function () {
        u.apply(o, arguments);
      }, e.exports.polyfill = function (e) {
        e || (e = o), e.requestAnimationFrame = l, e.cancelAnimationFrame = u;
      };
    }).call(this, n(27));
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, o;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : void 0 !== t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - o) / 1e6;
        }, r = t.hrtime, o = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })()) : Date.now ? (e.exports = function () {
          return Date.now() - o;
        }, o = Date.now()) : (e.exports = function () {
          return new Date().getTime() - o;
        }, o = new Date().getTime());
      }).call(this);
    }).call(this, n(9));
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e, t, n, o, i, a, l) {
      var u = n + (-i * (t - o) + -a * n) * e,
          s = t + u * e;
      if (Math.abs(u) < l && Math.abs(s - o) < l) return r[0] = o, r[1] = 0, r;
      return r[0] = s, r[1] = u, r;
    };
    var r = [0, 0];
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e) {
      var t = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && (t[n] = 0);
      }

      return t;
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = {
      noWobble: {
        stiffness: 170,
        damping: 26
      },
      gentle: {
        stiffness: 120,
        damping: 14
      },
      wobbly: {
        stiffness: 180,
        damping: 12
      },
      stiff: {
        stiffness: 210,
        damping: 20
      }
    }, e.exports = t.default;
  }, function (e, t) {
    var n,
        r,
        o = e.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function l(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        n = i;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        r = a;
      }
    }();
    var u,
        s = [],
        c = !1,
        f = -1;

    function p() {
      c && u && (c = !1, u.length ? s = u.concat(s) : f = -1, s.length && d());
    }

    function d() {
      if (!c) {
        var e = l(p);
        c = !0;

        for (var t = s.length; t;) {
          for (u = s, s = []; ++f < t;) {
            u && u[f].run();
          }

          f = -1, t = s.length;
        }

        u = null, c = !1, function (e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function y(e, t) {
      this.fun = e, this.array = t;
    }

    function h() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      s.push(new y(e, t)), 1 !== s.length || c || l(d);
    }, y.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = h, o.addListener = h, o.once = h, o.off = h, o.removeListener = h, o.removeAllListeners = h, o.emit = h, o.prependListener = h, o.prependOnceListener = h, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e.default : e;
    }

    t.__esModule = !0;
    var o = n(28);
    t.Motion = r(o);
    var i = n(21);
    t.StaggeredMotion = r(i);
    var a = n(20);
    t.TransitionMotion = r(a);
    var l = n(18);
    t.spring = r(l);
    var u = n(8);
    t.presets = r(u);
    var s = n(2);
    t.stripStyle = r(s);
    var c = n(17);
    t.reorderKeys = r(c);
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var o,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (e, t, n) {
    var r,
        o,
        i = {},
        a = (r = function r() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
        l = function (e) {
      var t = {};
      return function (e) {
        if ("function" == typeof e) return e();

        if (void 0 === t[e]) {
          var n = function (e) {
            return document.querySelector(e);
          }.call(this, e);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        u = null,
        s = 0,
        c = [],
        f = n(11);

    function p(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
            o = i[r.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](r.parts[a]);
          }

          for (; a < r.parts.length; a++) {
            o.parts.push(b(r.parts[a], t));
          }
        } else {
          var l = [];

          for (a = 0; a < r.parts.length; a++) {
            l.push(b(r.parts[a], t));
          }

          i[r.id] = {
            id: r.id,
            refs: 1,
            parts: l
          };
        }
      }
    }

    function d(e, t) {
      for (var n = [], r = {}, o = 0; o < e.length; o++) {
        var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            l = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(l) : n.push(r[a] = {
          id: a,
          parts: [l]
        });
      }

      return n;
    }

    function y(e, t) {
      var n = l(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = c[c.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), c.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = l(e.insertInto + " " + e.insertAt.before);
        n.insertBefore(t, o);
      }
    }

    function h(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      t >= 0 && c.splice(t, 1);
    }

    function m(e) {
      var t = document.createElement("style");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), v(t, e.attrs), y(e, t), t;
    }

    function v(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function b(e, t) {
      var n, r, o, i;

      if (t.transform && e.css) {
        if (!(i = t.transform(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var a = s++;
        n = u || (u = m(t)), r = S.bind(null, n, a, !1), o = S.bind(null, n, a, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", v(t, e.attrs), y(e, t), t;
      }(t), r = function (e, t, n) {
        var r = n.css,
            o = n.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && o;
        (t.convertToAbsoluteUrls || i) && (r = f(r));
        o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            l = e.href;
        e.href = URL.createObjectURL(a), l && URL.revokeObjectURL(l);
      }.bind(null, n, t), o = function o() {
        h(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = m(t), r = function (e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        h(n);
      });

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = d(e, t);
      return p(n, t), function (e) {
        for (var r = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (l = i[a.id]).refs--, r.push(l);
        }

        e && p(d(e, t), t);

        for (o = 0; o < r.length; o++) {
          var l;

          if (0 === (l = r[o]).refs) {
            for (var u = 0; u < l.parts.length; u++) {
              l.parts[u]();
            }

            delete i[l.id];
          }
        }
      };
    };

    var g,
        w = (g = [], function (e, t) {
      return g[e] = t, g.filter(Boolean).join("\n");
    });

    function S(e, t, n, r) {
      var o = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = w(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                  i = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });
              return [n].concat(i).concat([o]).join("\n");
            }

            var a;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var a = e[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    (e.exports = n(13)(!1)).push([e.i, ".text-transition {\n  position: relative;\n}\n.text-transition .placeholder {\n  visibility: hidden;\n}\n.text-transition .text-transition-inner {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 115%;\n  width: 100%;\n}\n.text-transition .text-transition-inner .text {\n  position: absolute;\n  max-width: 100%;\n  display: inline-block;\n}\n", ""]);
  }, function (e, t, n) {
    var r = n(14);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    var o = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(12)(r, o);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        i = n(1),
        a = s(i),
        l = s(n(0)),
        u = n(10);

    function s(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    n(15);

    var c = function c(e) {
      return [{
        key: "" + Date.now(),
        style: {
          opacity: 1,
          top: 0
        },
        data: e
      }];
    },
        f = function (e) {
      function t(e) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        var n = function (e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));

        return n.state = {
          texts: c(e.text),
          width: 0
        }, n.timeout = 0, n.initialRender = !0, n.willLeave = n.willLeave.bind(n), n.willEnter = n.willEnter.bind(n), n.renderStuff = n.renderStuff.bind(n), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, i.PureComponent), o(t, [{
        key: "componentDidMount",
        value: function value() {
          this.setWidth(this.props.text);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = this,
              n = e.order,
              r = e.text;
          r !== this.props.text && (this.direction = n < this.props.order, this.timeout = setTimeout(function () {
            t.setWidth(r), t.setState({
              texts: c(r)
            });
          }, this.props.delay));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          clearTimeout(this.timeout);
        }
      }, {
        key: "setWidth",
        value: function value(e) {
          this.placeholder.innerHTML = e, this.props.inline && this.setState({
            width: this.placeholder.offsetWidth
          });
        }
      }, {
        key: "willLeave",
        value: function value() {
          return {
            opacity: (0, u.spring)(0, this.props.spring),
            top: (0, u.spring)(this.direction ? 70 : -70, this.props.spring)
          };
        }
      }, {
        key: "willEnter",
        value: function value() {
          return {
            opacity: 0,
            top: this.direction ? -70 : 70
          };
        }
      }, {
        key: "renderStuff",
        value: function value() {
          var e = this,
              t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).width;
          return a.default.createElement("span", {
            className: "text-transition " + this.props.className,
            style: r({
              display: this.props.inline ? "inline-block" : "block",
              width: t || "100%",
              whiteSpace: this.props.inline ? "nowrap" : "normal",
              height: this.props.inline ? "auto" : "100%"
            }, this.props.style)
          }, a.default.createElement("span", {
            ref: function ref(t) {
              e.placeholder = t;
            },
            className: "placeholder"
          }), a.default.createElement(u.TransitionMotion, {
            willLeave: this.willLeave,
            willEnter: this.willEnter,
            styles: this.state.texts.map(function (t) {
              return r({}, t, {
                style: {
                  opacity: (0, u.spring)(t.style.opacity, e.props.spring),
                  top: (0, u.spring)(t.style.top, e.props.spring)
                }
              });
            })
          }, function (t) {
            return a.default.createElement("div", {
              className: "text-transition-inner",
              style: {
                overflow: e.props.overflow ? "visible" : "hidden"
              }
            }, t.map(function (e) {
              return a.default.createElement("div", {
                className: "text",
                key: e.key,
                style: {
                  opacity: e.style.opacity,
                  top: e.style.top + "%"
                }
              }, e.data);
            }));
          }));
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.inline ? a.default.createElement(u.Motion, {
            style: {
              width: (0, u.spring)(this.state.width, this.props.spring)
            }
          }, this.renderStuff) : this.renderStuff();
        }
      }]), t;
    }();

    f.propTypes = {
      text: l.default.oneOfType([l.default.string, l.default.number]).isRequired,
      order: l.default.number,
      inline: l.default.bool,
      delay: l.default.number,
      className: l.default.string,
      style: l.default.object,
      overflow: l.default.bool,
      spring: l.default.shape({
        stiffness: l.default.number,
        damping: l.default.number
      })
    }, f.defaultProps = {
      order: 0,
      inline: !1,
      spring: {
        stiffness: 170,
        damping: 26
      },
      overflow: !1,
      delay: 0,
      className: "",
      style: {}
    }, t.default = f;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function () {
      0;
    };
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    };

    t.default = function (e, t) {
      return r({}, l, t, {
        val: e
      });
    };

    var o,
        i = n(8),
        a = (o = i) && o.__esModule ? o : {
      default: o
    },
        l = r({}, a.default.noWobble, {
      precision: .01
    });
    e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0, t.default = function (e, t, n) {
      for (var r = {}, o = 0; o < e.length; o++) {
        r[e[o].key] = o;
      }

      for (var i = {}, o = 0; o < t.length; o++) {
        i[t[o].key] = o;
      }

      for (var a = [], o = 0; o < t.length; o++) {
        a[o] = t[o];
      }

      for (var o = 0; o < e.length; o++) {
        if (!Object.prototype.hasOwnProperty.call(i, e[o].key)) {
          var l = n(o, e[o]);
          null != l && a.push(l);
        }
      }

      return a.sort(function (e, n) {
        var o = i[e.key],
            a = i[n.key],
            l = r[e.key],
            u = r[n.key];
        if (null != o && null != a) return i[e.key] - i[n.key];
        if (null != l && null != u) return r[e.key] - r[n.key];

        if (null != o) {
          for (var s = 0; s < t.length; s++) {
            var c = t[s].key;

            if (Object.prototype.hasOwnProperty.call(r, c)) {
              if (o < i[c] && u > r[c]) return -1;
              if (o > i[c] && u < r[c]) return 1;
            }
          }

          return 1;
        }

        for (var s = 0; s < t.length; s++) {
          var c = t[s].key;

          if (Object.prototype.hasOwnProperty.call(r, c)) {
            if (a < i[c] && l > r[c]) return 1;
            if (a > i[c] && l < r[c]) return -1;
          }
        }

        return -1;
      });
    }, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = i(n(7)),
        l = i(n(2)),
        u = i(n(6)),
        s = i(n(19)),
        c = i(n(5)),
        f = i(n(4)),
        p = i(n(3)),
        d = i(n(1)),
        y = i(n(0)),
        h = 1e3 / 60;

    function m(e, t, n) {
      var r = t;
      return null == r ? e.map(function (e, t) {
        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      }) : e.map(function (e, t) {
        for (var o = 0; o < r.length; o++) {
          if (r[o].key === e.key) return {
            key: r[o].key,
            data: r[o].data,
            style: n[t]
          };
        }

        return {
          key: e.key,
          data: e.data,
          style: n[t]
        };
      });
    }

    function v(e, t, n, r, o, i, l, u, c) {
      for (var f = s.default(r, o, function (e, r) {
        var o = t(r);
        return null == o ? (n({
          key: r.key,
          data: r.data
        }), null) : p.default(i[e], o, l[e]) ? (n({
          key: r.key,
          data: r.data
        }), null) : {
          key: r.key,
          data: r.data,
          style: o
        };
      }), d = [], y = [], h = [], m = [], v = 0; v < f.length; v++) {
        for (var b = f[v], g = null, w = 0; w < r.length; w++) {
          if (r[w].key === b.key) {
            g = w;
            break;
          }
        }

        if (null == g) {
          var S = e(b);
          d[v] = S, h[v] = S;
          var T = a.default(b.style);
          y[v] = T, m[v] = T;
        } else d[v] = i[g], h[v] = u[g], y[v] = l[g], m[v] = c[g];
      }

      return [f, d, y, h, m];
    }

    var b = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.unmounting = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = v(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, e, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), n = t[0], i = t[1], a = t[2], l = t[3], u = t[4], s = 0; s < e.length; s++) {
            var c = e[s].style,
                f = !1;

            for (var p in c) {
              if (Object.prototype.hasOwnProperty.call(c, p)) {
                var d = c[p];
                "number" == typeof d && (f || (f = !0, i[s] = r({}, i[s]), a[s] = r({}, a[s]), l[s] = r({}, l[s]), u[s] = r({}, u[s]), n[s] = {
                  key: n[s].key,
                  data: n[s].data,
                  style: r({}, n[s].style)
                }), i[s][p] = d, a[s][p] = 0, l[s][p] = d, u[s][p] = 0, n[s].style[p] = d);
              }
            }
          }

          o.setState({
            currentStyles: i,
            currentVelocities: a,
            mergedPropsStyles: n,
            lastIdealStyles: l,
            lastIdealVelocities: u
          });
        }, this.startAnimationIfNecessary = function () {
          o.unmounting || (o.animationID = f.default(function (e) {
            if (!o.unmounting) {
              var t = o.props.styles,
                  n = "function" == typeof t ? t(m(o.state.mergedPropsStyles, o.unreadPropStyles, o.state.lastIdealStyles)) : t;
              if (function (e, t, n, r) {
                if (r.length !== t.length) return !1;

                for (var o = 0; o < r.length; o++) {
                  if (r[o].key !== t[o].key) return !1;
                }

                for (o = 0; o < r.length; o++) {
                  if (!p.default(e[o], t[o].style, n[o])) return !1;
                }

                return !0;
              }(o.state.currentStyles, n, o.state.currentVelocities, o.state.mergedPropsStyles)) return o.animationID = null, void (o.accumulatedTime = 0);
              var r = e || c.default(),
                  i = r - o.prevTime;
              if (o.prevTime = r, o.accumulatedTime = o.accumulatedTime + i, o.accumulatedTime > 10 * h && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

              for (var a = (o.accumulatedTime - Math.floor(o.accumulatedTime / h) * h) / h, l = Math.floor(o.accumulatedTime / h), s = v(o.props.willEnter, o.props.willLeave, o.props.didLeave, o.state.mergedPropsStyles, n, o.state.currentStyles, o.state.currentVelocities, o.state.lastIdealStyles, o.state.lastIdealVelocities), f = s[0], d = s[1], y = s[2], b = s[3], g = s[4], w = 0; w < f.length; w++) {
                var S = f[w].style,
                    T = {},
                    O = {},
                    I = {},
                    x = {};

                for (var P in S) {
                  if (Object.prototype.hasOwnProperty.call(S, P)) {
                    var k = S[P];
                    if ("number" == typeof k) T[P] = k, O[P] = 0, I[P] = k, x[P] = 0;else {
                      for (var j = b[w][P], _ = g[w][P], M = 0; M < l; M++) {
                        var R = u.default(h / 1e3, j, _, k.val, k.stiffness, k.damping, k.precision);
                        j = R[0], _ = R[1];
                      }

                      var D = u.default(h / 1e3, j, _, k.val, k.stiffness, k.damping, k.precision),
                          E = D[0],
                          L = D[1];
                      T[P] = j + (E - j) * a, O[P] = _ + (L - _) * a, I[P] = j, x[P] = _;
                    }
                  }
                }

                b[w] = I, g[w] = x, d[w] = T, y[w] = O;
              }

              o.animationID = null, o.accumulatedTime -= l * h, o.setState({
                currentStyles: d,
                currentVelocities: y,
                lastIdealStyles: b,
                lastIdealVelocities: g,
                mergedPropsStyles: f
              }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
            }
          }));
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: y.default.arrayOf(y.default.shape({
            key: y.default.string.isRequired,
            data: y.default.any,
            style: y.default.objectOf(y.default.number).isRequired
          })),
          styles: y.default.oneOfType([y.default.func, y.default.arrayOf(y.default.shape({
            key: y.default.string.isRequired,
            data: y.default.any,
            style: y.default.objectOf(y.default.oneOfType([y.default.number, y.default.object])).isRequired
          }))]).isRequired,
          children: y.default.func.isRequired,
          willEnter: y.default.func,
          willLeave: y.default.func,
          didLeave: y.default.func
        },
        enumerable: !0
      }, {
        key: "defaultProps",
        value: {
          willEnter: function willEnter(e) {
            return l.default(e.style);
          },
          willLeave: function willLeave() {
            return null;
          },
          didLeave: function didLeave() {}
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = e.willEnter,
            o = e.willLeave,
            i = e.didLeave,
            u = "function" == typeof n ? n(t) : n,
            s = void 0;
        s = null == t ? u : t.map(function (e) {
          for (var t = 0; t < u.length; t++) {
            if (u[t].key === e.key) return u[t];
          }

          return e;
        });
        var c = null == t ? u.map(function (e) {
          return l.default(e.style);
        }) : t.map(function (e) {
          return l.default(e.style);
        }),
            f = null == t ? u.map(function (e) {
          return a.default(e.style);
        }) : t.map(function (e) {
          return a.default(e.style);
        }),
            p = v(r, o, i, s, u, c, f, c, f),
            d = p[0];
        return {
          currentStyles: p[1],
          currentVelocities: p[2],
          lastIdealStyles: p[3],
          lastIdealVelocities: p[4],
          mergedPropsStyles: d
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = c.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles);
        var t = e.styles;
        this.unreadPropStyles = "function" == typeof t ? t(m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles)) : t, null == this.animationID && (this.prevTime = c.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        this.unmounting = !0, null != this.animationID && (f.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = m(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles),
            t = this.props.children(e);
        return t && d.default.Children.only(t);
      }, t;
    }(d.default.Component);

    t.default = b, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = i(n(7)),
        l = i(n(2)),
        u = i(n(6)),
        s = i(n(5)),
        c = i(n(4)),
        f = i(n(3)),
        p = i(n(1)),
        d = i(n(0)),
        y = 1e3 / 60;

    var h = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyles = null, this.clearUnreadPropStyle = function (e) {
          for (var t = o.state, n = t.currentStyles, i = t.currentVelocities, a = t.lastIdealStyles, l = t.lastIdealVelocities, u = !1, s = 0; s < e.length; s++) {
            var c = e[s],
                f = !1;

            for (var p in c) {
              if (Object.prototype.hasOwnProperty.call(c, p)) {
                var d = c[p];
                "number" == typeof d && (f || (f = !0, u = !0, n[s] = r({}, n[s]), i[s] = r({}, i[s]), a[s] = r({}, a[s]), l[s] = r({}, l[s])), n[s][p] = d, i[s][p] = 0, a[s][p] = d, l[s][p] = 0);
              }
            }
          }

          u && o.setState({
            currentStyles: n,
            currentVelocities: i,
            lastIdealStyles: a,
            lastIdealVelocities: l
          });
        }, this.startAnimationIfNecessary = function () {
          o.animationID = c.default(function (e) {
            var t = o.props.styles(o.state.lastIdealStyles);
            if (function (e, t, n) {
              for (var r = 0; r < e.length; r++) {
                if (!f.default(e[r], t[r], n[r])) return !1;
              }

              return !0;
            }(o.state.currentStyles, t, o.state.currentVelocities)) return o.animationID = null, void (o.accumulatedTime = 0);
            var n = e || s.default(),
                r = n - o.prevTime;
            if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * y && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();

            for (var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / y) * y) / y, a = Math.floor(o.accumulatedTime / y), l = [], c = [], p = [], d = [], h = 0; h < t.length; h++) {
              var m = t[h],
                  v = {},
                  b = {},
                  g = {},
                  w = {};

              for (var S in m) {
                if (Object.prototype.hasOwnProperty.call(m, S)) {
                  var T = m[S];
                  if ("number" == typeof T) v[S] = T, b[S] = 0, g[S] = T, w[S] = 0;else {
                    for (var O = o.state.lastIdealStyles[h][S], I = o.state.lastIdealVelocities[h][S], x = 0; x < a; x++) {
                      var P = u.default(y / 1e3, O, I, T.val, T.stiffness, T.damping, T.precision);
                      O = P[0], I = P[1];
                    }

                    var k = u.default(y / 1e3, O, I, T.val, T.stiffness, T.damping, T.precision),
                        j = k[0],
                        _ = k[1];
                    v[S] = O + (j - O) * i, b[S] = I + (_ - I) * i, g[S] = O, w[S] = I;
                  }
                }
              }

              p[h] = v, d[h] = b, l[h] = g, c[h] = w;
            }

            o.animationID = null, o.accumulatedTime -= a * y, o.setState({
              currentStyles: p,
              currentVelocities: d,
              lastIdealStyles: l,
              lastIdealVelocities: c
            }), o.unreadPropStyles = null, o.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyles: d.default.arrayOf(d.default.objectOf(d.default.number)),
          styles: d.default.func.isRequired,
          children: d.default.func.isRequired
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyles,
            n = e.styles,
            r = t || n().map(l.default),
            o = r.map(function (e) {
          return a.default(e);
        });
        return {
          currentStyles: r,
          currentVelocities: o,
          lastIdealStyles: r,
          lastIdealVelocities: o
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = s.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyles && this.clearUnreadPropStyle(this.unreadPropStyles), this.unreadPropStyles = e.styles(this.state.lastIdealStyles), null == this.animationID && (this.prevTime = s.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (c.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyles);
        return e && p.default.Children.only(e);
      }, t;
    }(p.default.Component);

    t.default = h, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {};

    e.exports = function (e, t, n, o, i, a, l, u) {
      if (r(t), !e) {
        var s;
        if (void 0 === t) s = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [n, o, i, a, l, u],
              f = 0;
          (s = new Error(t.replace(/%s/g, function () {
            return c[f++];
          }))).name = "Invariant Violation";
        }
        throw s.framesToPop = 1, s;
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(24),
        o = n(23),
        i = n(22);

    e.exports = function () {
      function e(e, t, n, r, a, l) {
        l !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    (function (t) {
      (function () {
        var n, r, o, i, a, l;
        "undefined" != typeof performance && null !== performance && performance.now ? e.exports = function () {
          return performance.now();
        } : void 0 !== t && null !== t && t.hrtime ? (e.exports = function () {
          return (n() - a) / 1e6;
        }, r = t.hrtime, i = (n = function n() {
          var e;
          return 1e9 * (e = r())[0] + e[1];
        })(), l = 1e9 * t.uptime(), a = i - l) : Date.now ? (e.exports = function () {
          return Date.now() - o;
        }, o = Date.now()) : (e.exports = function () {
          return new Date().getTime() - o;
        }, o = new Date().getTime());
      }).call(this);
    }).call(this, n(9));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = i(n(7)),
        l = i(n(2)),
        u = i(n(6)),
        s = i(n(5)),
        c = i(n(4)),
        f = i(n(3)),
        p = i(n(1)),
        d = i(n(0)),
        y = 1e3 / 60,
        h = function (e) {
      function t(n) {
        var o = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e.call(this, n), this.wasAnimating = !1, this.animationID = null, this.prevTime = 0, this.accumulatedTime = 0, this.unreadPropStyle = null, this.clearUnreadPropStyle = function (e) {
          var t = !1,
              n = o.state,
              i = n.currentStyle,
              a = n.currentVelocity,
              l = n.lastIdealStyle,
              u = n.lastIdealVelocity;

          for (var s in e) {
            if (Object.prototype.hasOwnProperty.call(e, s)) {
              var c = e[s];
              "number" == typeof c && (t || (t = !0, i = r({}, i), a = r({}, a), l = r({}, l), u = r({}, u)), i[s] = c, a[s] = 0, l[s] = c, u[s] = 0);
            }
          }

          t && o.setState({
            currentStyle: i,
            currentVelocity: a,
            lastIdealStyle: l,
            lastIdealVelocity: u
          });
        }, this.startAnimationIfNecessary = function () {
          o.animationID = c.default(function (e) {
            var t = o.props.style;
            if (f.default(o.state.currentStyle, t, o.state.currentVelocity)) return o.wasAnimating && o.props.onRest && o.props.onRest(), o.animationID = null, o.wasAnimating = !1, void (o.accumulatedTime = 0);
            o.wasAnimating = !0;
            var n = e || s.default(),
                r = n - o.prevTime;
            if (o.prevTime = n, o.accumulatedTime = o.accumulatedTime + r, o.accumulatedTime > 10 * y && (o.accumulatedTime = 0), 0 === o.accumulatedTime) return o.animationID = null, void o.startAnimationIfNecessary();
            var i = (o.accumulatedTime - Math.floor(o.accumulatedTime / y) * y) / y,
                a = Math.floor(o.accumulatedTime / y),
                l = {},
                c = {},
                p = {},
                d = {};

            for (var h in t) {
              if (Object.prototype.hasOwnProperty.call(t, h)) {
                var m = t[h];
                if ("number" == typeof m) p[h] = m, d[h] = 0, l[h] = m, c[h] = 0;else {
                  for (var v = o.state.lastIdealStyle[h], b = o.state.lastIdealVelocity[h], g = 0; g < a; g++) {
                    var w = u.default(y / 1e3, v, b, m.val, m.stiffness, m.damping, m.precision);
                    v = w[0], b = w[1];
                  }

                  var S = u.default(y / 1e3, v, b, m.val, m.stiffness, m.damping, m.precision),
                      T = S[0],
                      O = S[1];
                  p[h] = v + (T - v) * i, d[h] = b + (O - b) * i, l[h] = v, c[h] = b;
                }
              }
            }

            o.animationID = null, o.accumulatedTime -= a * y, o.setState({
              currentStyle: p,
              currentVelocity: d,
              lastIdealStyle: l,
              lastIdealVelocity: c
            }), o.unreadPropStyle = null, o.startAnimationIfNecessary();
          });
        }, this.state = this.defaultState();
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), o(t, null, [{
        key: "propTypes",
        value: {
          defaultStyle: d.default.objectOf(d.default.number),
          style: d.default.objectOf(d.default.oneOfType([d.default.number, d.default.object])).isRequired,
          children: d.default.func.isRequired,
          onRest: d.default.func
        },
        enumerable: !0
      }]), t.prototype.defaultState = function () {
        var e = this.props,
            t = e.defaultStyle,
            n = e.style,
            r = t || l.default(n),
            o = a.default(r);
        return {
          currentStyle: r,
          currentVelocity: o,
          lastIdealStyle: r,
          lastIdealVelocity: o
        };
      }, t.prototype.componentDidMount = function () {
        this.prevTime = s.default(), this.startAnimationIfNecessary();
      }, t.prototype.componentWillReceiveProps = function (e) {
        null != this.unreadPropStyle && this.clearUnreadPropStyle(this.unreadPropStyle), this.unreadPropStyle = e.style, null == this.animationID && (this.prevTime = s.default(), this.startAnimationIfNecessary());
      }, t.prototype.componentWillUnmount = function () {
        null != this.animationID && (c.default.cancel(this.animationID), this.animationID = null);
      }, t.prototype.render = function () {
        var e = this.props.children(this.state.currentStyle);
        return e && p.default.Children.only(e);
      }, t;
    }(p.default.Component);

    t.default = h, e.exports = t.default;
  }, function (e, t, n) {
    "use strict";

    var r,
        o = n(10),
        i = n(16),
        a = (r = i) && r.__esModule ? r : {
      default: r
    };
    a.default.presets = o.presets, e.exports = a.default;
  }]);
});